// extracted by mini-css-extract-plugin
module.exports = {"patientCol":"Table_patientCol__Kk7xj"};